import { Box, Typography } from '@mui/material';
import React, { useState } from 'react';

import { useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import { useActions } from '../hooks/useActions';
import { useIntercomComponentOnOpenEventTrack } from '../hooks/useIntercomComponentOnOpenEventTrack';

import { SessionChart } from '../components/Sessions/SessionDetail/SessionChart/SessionChart';
import { useSessionDetailsCard } from '../components/Sessions/hooks/useSessionDetailsCard';
import { SessionClientCard } from '../components/Sessions/SessionDetail/SessionClientCard/SessionClientCard';
import { ReassignClientModal } from '../components/Sessions/ReassignClientModal/ReassignClientModal';
import { useSessionDetailPolling } from '../components/Sessions/hooks/useSessionDetailPolling';

import { sessionDetailStyle } from './style';

export const SessionDetail = (props) => {
  const { match } = props;
  const { t } = useTranslation();
  const { sessionDetail } = sessionDetailStyle;

  const { selectedSession } = useSelector((state) => state.sessions);
  const { practitioner } = useSelector((state) => state.authentication);

  const { findSessionById } = useActions();

  const [sessionId] = useState(match.params.id);
  const [reassignModalIsOpen, setReassignModalIsOpen] = useState(false);

  const copiedSession = JSON.parse(JSON.stringify(selectedSession));
  const sessionAttributes = copiedSession?.attributes || {};
  delete copiedSession?.attributes;
  const combinedSessionObject = { ...copiedSession, ...sessionAttributes };

  const sessionDetailsLayout = useSessionDetailsCard(combinedSessionObject);

  const openReassignClientModal = () => setReassignModalIsOpen(true);
  const closeReassignClientModal = () => setReassignModalIsOpen(false);

  useSessionDetailPolling(sessionId, findSessionById);

  useIntercomComponentOnOpenEventTrack('page-visit', {
    name: 'Sessions Details',
  });

  return (
    <Box sx={sessionDetail}>
      <Box className='page-header'>
        <Typography variant='h1' className='main-title'>
          {t('session-detail.title')}
        </Typography>
      </Box>
      <Box className='session-detail-container'>
        <SessionChart
          sudScore={combinedSessionObject?.sud_array}
          vocScore={combinedSessionObject?.validity_of_cognition_array}
        />
        <Box className='detail-grid'>
          {practitioner && (
            <SessionClientCard
              openReassignClientModal={openReassignClientModal}
            />
          )}
          {sessionDetailsLayout}
        </Box>
      </Box>
      <ReassignClientModal
        reassignModalIsOpen={reassignModalIsOpen}
        closeReassignClientModal={closeReassignClientModal}
      />
    </Box>
  );
};
